import * as React from 'react'
import { Pulse } from '../../../app-core/lib/ui/Pulse'
import { DS_getData } from '../DS/DS.Data'
import { Proc_getProcedures } from '../Proc/Proc.getProcedures'
import type { Proc_Procedure } from '../Proc/Proc.Procedure'
import { Rout_toActivityBase } from '../Rout/Rout.activity'
import { Rpts_enoughSpaceToStartReport } from '../Rpts/Rpts.enoughSpaceToStartReport'
import { Rpts_openReportFetch } from '../Rpts/Rpts.OpenReport'
import { Rpts_noSpaceWarningDialog } from '../Rpts/Rpts.ui.NoSpaceWarning'
import { UI_dialogClose, UI_dialogOpen } from '../UI/UI.Dialog'
import { WF_formatOpenWorkflow } from './WF.formatOpenWorkflow'
import { WF_getRecentlyUsedWorkflows } from './WF.getRecentlyUsedWorkflows'
import { WF_startAdHocReport } from './WF.startAdHocReport'
import { WF_ChooseWorkflow } from './WF.ui.ChooseWorkflow'
import type { FlowContinuationId } from '../../../app-core/lib/flow/FlowReport'
import { Logg_createLogger } from '../Logg/Logg.Logger'
import { WF_fetchMissingTrainingRecommendationsBulk } from './WF.fetchMissingTrainingRecommendations'

export async function WF_openWorkflowDialog(createContinuation?: () => Promise<FlowContinuationId>) {
    const logger = Logg_createLogger('WF_openWorkflowDialog')

    // Check space
    if (!(await Rpts_enoughSpaceToStartReport(DS_getData().serverPrefs))) {
        return Rpts_noSpaceWarningDialog(logger)
    }

    UI_dialogOpen({ key: 'choose-workflow-dialog' }, <Pulse />)

    const openReport = await Rpts_openReportFetch()
    const openWorkflow = openReport ? await WF_formatOpenWorkflow(openReport) : null

    const procedures: Proc_Procedure[] = await Proc_getProcedures(logger, DS_getData().user)
    const recentlyUsedWorkflows = await WF_getRecentlyUsedWorkflows(procedures)

    const taskWorkflowIds = procedures.flatMap((procedure) =>
        procedure.workflows.filter((wf) => wf.type === 'task').map((wf) => wf.id)
    )
    const missingTrainingRecommendationsMap = await WF_fetchMissingTrainingRecommendationsBulk(logger, taskWorkflowIds)

    // Capture the current state of ongoing report so it can be continued
    const previousReport = createContinuation != null ? await createContinuation() : null

    logger.log('opening choose workflow dialog')

    UI_dialogOpen(
        {
            key: 'choose-workflow-dialog',
            className: 'WF_ChooseWorkflow_dialog-root',
            overlayClassName: 'WF_ChooseWorkflow_dialog-overlay',
            contentClassName: 'WF_ChooseWorkflow_dialog-content',
            bodyClassName: 'WF_ChooseWorkflow_dialog-body',
            onRequestClose: () => {
                UI_dialogClose()
            },
        },
        <WF_ChooseWorkflow
            openWorkflow={openWorkflow}
            procedures={procedures}
            recentlyUsedWorkflows={recentlyUsedWorkflows}
            missingTrainingRecommendationsMap={missingTrainingRecommendationsMap}
            onClose={() => {
                UI_dialogClose()
            }}
            onWorkflowSelect={async (workflowId: number, procedureId: number) => {
                await WF_startAdHocReport(logger, workflowId, procedureId, { previousReport })
                UI_dialogClose()
            }}
            onInProgressSelect={() => {
                Rout_toActivityBase()
                UI_dialogClose()
            }}
        />
    )
}
